import { type Product } from '@/services/products/types';
import { Stars } from '@johnlewispartnership/wtr-ingredients/ingredients/StarRating/Stars';
import DiscountLabel from '@/components/DiscountLabel/DiscountLabel';
import styles from '../ProductPod.module.scss';

export function ProductReviewAndDiscount({ product }: { product: Product }) {
  const { discount, rating } = product;
  return (
    <>
      <div className={styles.rating}>
        {rating && rating.count > 0 && (
          <>
            <Stars rating={rating.averageRating} />
            <span data-testid="product-rating">({rating.count})</span>
          </>
        )}
        {rating && rating.count === 0 && <span>No reviews yet</span>}
        {!rating && <span>No reviews yet</span>}
      </div>
      {discount && (
        <DiscountLabel
          discountLabel={discount.discountLabel}
          originalFormattedPrice={discount.pricePerUnit?.originalPrice.formatted}
        />
      )}
    </>
  );
}
